import Box from '@mui/material/Box';
import { Outlet, useLocation } from 'react-router';
import { Link } from '@components/index';
import { Path } from '../../../assets/enums/index.ts';
import { HomeIcon } from '../../../assets/icons/home.tsx';
import { type Theme, useTheme } from '@mui/material';

export const AppWrapperLayout = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  return (
    <Box height={'100%'} position={'relative'}>
      <Link
        to={Path.Home}
        sx={linkSx(theme, pathname)}
      ><HomeIcon /></Link>
      <Outlet />
    </Box>
  );
};
const linkSx = (theme: Theme, pathname: string) => {
  const shouldHide = pathname === Path.Home;
  let color = theme.palette.white_60;
  let bgColor = theme.palette.white_15;
  if (
    pathname === Path.Game || pathname === Path.StartGame
  ) {
    color = theme.palette.white_100;
    bgColor = theme.palette.dark;
  }
  return {
    zIndex: 99,
    position: 'absolute',
    right: 0,
    top: 0,
    p: 4,
    borderRadius: ' 0 0 0 24px',
    background: bgColor,
    color: color,
    visibility: shouldHide ? 'hidden' : 'visible',
  };
};